<script lang="ts">
	import { run } from 'svelte/legacy';

	import { initializeAnalytics } from '$lib/analyticsPosthog';
	import { onMount } from 'svelte';
	import '../app.postcss';
	import { openGraphTags } from '$lib/common';
	import { page } from '$app/stores';
	import { navigationIsDelayed } from '$lib/navigationIsDelayed';
	import { fade } from 'svelte/transition';
	import IconFlower from '$lib/icons/IconFlower.svelte';
	import posthog from 'posthog-js';
	import { invalidate, afterNavigate, beforeNavigate, invalidateAll } from '$app/navigation';
	import { browser } from '$app/environment';
	import { defineGetLocale, defineSetLocale, getLocale, setLocale } from '$lib/paraglide/runtime';

	let { data, children } = $props();

	initializeAnalytics();

	let isEventPage = $derived($page.url.pathname.split('/')?.[1] === 'e' && $page.url.pathname.split('/').length === 3);

	let { supabase, session } = $state(data);
	run(() => {
		({ supabase, session } = data);
	});

	if (browser) {
		beforeNavigate(() => posthog.capture('$pageleave'));
		afterNavigate(() => posthog.capture('$pageview'));
	}

	let mounted = $state(false);
	onMount(() => {
		mounted = true; // sometimes in playwright inputs are not properly registered if svelte is not mounted yet

		supabase.auth.onAuthStateChange((event, _session) => {
			if (_session?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth');
			}
		});
	});

	if (!import.meta.env.SSR) {
		defineGetLocale(() => {
			return data.locale as 'de' | 'en';
		});
		defineSetLocale((newLocale) => {
			console.log('changing locale to ' + newLocale);
			document.cookie = `locale=${newLocale}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax; ${
				process.env.NODE_ENV === 'production' ? 'secure;' : ''
			}`;
			invalidateAll();
		});
	}
</script>

<svelte:head>
	{#if data.isNotRouteToEvent}
		{@html openGraphTags()}
	{/if}
</svelte:head>

{#if $navigationIsDelayed}
	<div class="fixed z-30 h-full w-full" in:fade={{ duration: 200 }}>
		<div class="absolute z-30 h-full w-full bg-white/30 backdrop-blur-sm"></div>
		<div class="absolute z-40 flex h-full w-full items-center justify-center text-4xl">
			<div class="rounded-full shadow-xl">
				<div class="rounded-full bg-violet-700 p-2 shadow-md">
					<IconFlower class=" animate-spin text-violet-100"></IconFlower>
				</div>
			</div>
		</div>
	</div>
{/if}

{@render children?.()}

<div data-testid="sveltekit-mounted" class="hidden">{mounted}</div>
